//action creator
//function -> object (action)
import { FETCH_POSTS, LOADING_SET } from "./actionType";

export const fetchPostSuccess = (payload) => {
	return {
		type: FETCH_POSTS,
		payload,
	};
};

export const loadingSet = (payload) => {
	return {
		type: LOADING_SET,
		payload,
	};
};

export const fetchPost = () => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch("https://terkini-rysaldi.herokuapp.com/admin/posts", {
		headers: {
			access_token: localStorage.access_token,
		},
	})
		.then(async (res) => {
			if (!res.ok) {
				const isJson = res.headers.get("content-type")?.includes("application/json");
				const data = isJson ? await res.json() : null;
				const error = (data && data.message) || res.status;
				return Promise.reject(error);
			}
			return res.json();
		})
		.then((data) => {
			dispatch(fetchPostSuccess(data));
		});
};

export const addPost = (newPost, newTags) => (dispatch) => {
	dispatch(loadingSet(true));
	const data = { ...newPost, tags: newTags };
	return fetch("https://terkini-rysaldi.herokuapp.com/admin/posts", {
		method: "POST",
		body: JSON.stringify(data),
		headers: {
			"Content-Type": "application/json",
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
		return res.json();
	});
};

export const deletePost = (postId) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch(`https://terkini-rysaldi.herokuapp.com/admin/posts/${postId}`, {
		method: "DELETE",
		headers: {
			access_token: localStorage.access_token,
		},
	})
		.then(async (res) => {
			if (!res.ok) {
				const isJson = res.headers.get("content-type")?.includes("application/json");
				const data = isJson ? await res.json() : null;
				const error = (data && data.message) || res.status;
				return Promise.reject(error);
			}
			return res.json();
		})
		.then(() => {
			dispatch(fetchPost());
		});
};

export const fetchDetailPost = (postId) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch(`https://terkini-rysaldi.herokuapp.com/admin/posts/${postId}`, {
		headers: {
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
		return res.json();
	});
};

export const editDetailPost = (postId, newPost) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch(`https://terkini-rysaldi.herokuapp.com/admin/posts/${postId}`, {
		method: "PUT",
		body: JSON.stringify(newPost),
		headers: {
			"Content-Type": "application/json",
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
		return res.json();
	});
};
